import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Elevator',
  path: '/homenet/elevator',
  redirect: '/homenet/elevator/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Elevator List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/ElevatorList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/elevator.js